import React from 'react';
import type {AssignmentRuleExceptionsProps as SharedProps} from 'src/app/assignment-rules/AssignmentRuleExceptions';
import {AssignmentRuleExceptions as SharedAssignmentRuleExceptions} from 'src/app/assignment-rules/AssignmentRuleExceptions';
import {
  useAddProjectAssignmentRuleExceptionMutation,
  useListProjectAssignmentRuleExceptionsQuery,
  useRemoveProjectAssignmentRuleExceptionMutation,
} from 'src/redux/queries/projectAssignmentRule';

export type AssignmentRuleExceptionsProps = Pick<
  SharedProps,
  'ruleId' | 'canEdit'
>;

export const AssignmentRuleExceptions: React.FC<
  AssignmentRuleExceptionsProps
> = ({ruleId, canEdit}) => (
  <SharedAssignmentRuleExceptions
    ruleId={ruleId}
    canEdit={canEdit}
    matchedVerb="assigned"
    useListExceptionsQuery={useListProjectAssignmentRuleExceptionsQuery}
    useAddExceptionMutation={useAddProjectAssignmentRuleExceptionMutation}
    useRemoveExceptionMutation={useRemoveProjectAssignmentRuleExceptionMutation}
  />
);
